export default __webpack_public_path__ + "static/centered-results-1-8098ea47ffbb2c0bd3b93511db6883eb.png";